module.exports = __webpack_public_path__ + "img/app_store.ce1d6ec2.svg";